import React from "react";
import { Link } from 'react-router-dom'
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";

import AppDownloadBanner from "@/components/AppDownloadBanner";
import ParticipantDistributionChart from "@/components/ParticipantDistributionChart";
import AllExperimentsStatsCards from "@/components/AllExperimentsStatsCards";
import { useExperiments } from "@/hooks/useExperiments";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import ExperimentStatusBadge from "@/components/ExperimentStatusBadge";

const Dashboard: React.FC = () => {
  const { data: experiments, isLoading: experimentsLoading } = useExperiments();

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold">Dashboard</h1>
          <p className="text-muted-foreground">
            Welcome back, here's an overview of your experiments
          </p>
        </div>
        <Button asChild>
          <Link to="/dashboard/experiments">Go to experiments</Link>
        </Button>
      </div>

      <AllExperimentsStatsCards />

      <div className="grid gap-4">
        {/* Experiments list with loading state */}
        {experimentsLoading ? (
          <div className="space-y-4">
            <Skeleton className="h-8 w-64" />
            <Skeleton className="h-64 w-full" />
          </div>
        ) : (
          <Card>
            <CardHeader>
              <CardTitle>Experiments</CardTitle>
            </CardHeader>
            <CardContent className="p-0">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Name</TableHead>
                    <TableHead>Status</TableHead>
                    <TableHead>Days</TableHead>
                    <TableHead>Participants</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {(experiments || []).slice(0, 10).map((experiment: any) => (
                    <TableRow key={experiment.id} className="hover:bg-muted/50">
                      <TableCell className="font-medium">
                        <Link to={`/dashboard/experiments/${experiment.id}`} className="hover:underline">
                          {experiment.name}
                        </Link>
                      </TableCell>
                      <TableCell><ExperimentStatusBadge status={experiment.status} /></TableCell>
                      <TableCell>{new Set((experiment.steps || []).map((s: any) => s.day)).size}</TableCell>
                      <TableCell>{experiment.participantsCount ?? 0}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardContent>
          </Card>
        )}

        {/* Participant Distribution and App Download Banner */}
        <div className="grid gap-4 md:grid-cols-2">
          <ParticipantDistributionChart />
          <AppDownloadBanner />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
